export const pages = {
	'boltIframe': { id: 'boltIframe', page: 'iframe', getter: () => import(/* webpackChunkName: 'boltIframe' */ 'components/bolt/iframe/iframe') },
	'boltSynopsis': { id: 'boltSynopsis', page: 'synopsis', getter: () => import(/* webpackChunkName: 'boltSynopsis' */ 'components/bolt/synopsis/synopsis') },
	'boltPreviewPanel': { id: 'boltPreviewPanel', page: 'home', getter: () => import(/* webpackChunkName: 'boltPreviewPanel' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltPreviewPanel', getter: () => import(/* webpackChunkName: "boltPreviewPanel" */ 'components/bolt/previewPanel/previewPanel'), component: 'previewPanel' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
